export const RECEIVE_CLAIMS_ENABLED = 'RECEIVE_CLAIMS_ENABLED';
export const RECEIVE_CLAIMS_SIDEBAR_INIT = 'RECEIVE_CLAIMS_SIDEBAR_INIT';
export const RECEIVE_CLAIMS_SIDEBAR_TOGGLE = 'RECEIVE_CLAIMS_SIDEBAR_TOGGLE';
export const RESET_CLAIMS_SIDEBAR = 'RESET_CLAIMS_SIDEBAR';
export const RECEIVE_SIDEBAR_CLAIM_ITEM = 'RECEIVE_SIDEBAR_CLAIM_ITEM';

export const receiveClaimsFlag = (enabled) => ({
  type: RECEIVE_CLAIMS_ENABLED,
  data: {
    enabled,
  },
});

export const receiveClaimSidebarItem = (sidebarItem) => ({
  type: RECEIVE_SIDEBAR_CLAIM_ITEM,
  data: {
    sidebarItem,
  },
});
